module.exports = __webpack_public_path__ + "static/media/hotel-bell.4be41ee6.png";